<template>
  <div class="py-4 container-fluid">
    <div class="card">
      <div class="card-header pb-0">
        <h6>Setting Akuntansi</h6>
        <ul class="nav nav-tabs mt-2">
          <li class="nav-item" v-for="(tab, i) in tabs" :key="'tab'+i">
            <a :class="'nav-link text-sm '+(activeTab == tab.key ? 'active' : '')" href="javascript:void(0)" @click="activeTab = tab.key">{{ tab.label }}</a>
          </li>
        </ul>
      </div>
      <div class="card-body">

        <!-- MAPPING -->
        <div v-if="activeTab == 'mapping'">
          <p class="text-xs">Akun COA yang dipakai jurnal otomatis. Perubahan langsung berlaku ke semua jurnal (termasuk yang sudah ada). Isi daftar akun di tab "Daftar Akun (COA)" dulu.</p>
          <table class="table table-sm align-items-center">
            <thead><tr><th class="text-xxs text-secondary">Transaksi</th><th class="text-xxs text-secondary" style="width: 45%;">Akun COA</th></tr></thead>
            <tbody>
              <tr v-for="(m, i) in setting.mappings" :key="'m'+i">
                <td class="text-xs">{{ m.description }} <span class="text-xxs text-secondary">({{ m.map_key }})</span></td>
                <td>
                  <select :class="'form-select form-select-sm '+(!m.account_code && requiredKeys.includes(m.map_key) ? 'border-danger' : '')" v-model="m.account_code">
                    <option :value="null">- belum diisi -</option>
                    <option v-for="(a, k) in setting.accounts" :key="'a'+k" :value="a.code">{{ a.code }} - {{ a.name }}</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
          <argon-button variant="gradient" color="success" size="sm" @click="saveMappings()">Simpan Mapping</argon-button>
        </div>

        <!-- COA -->
        <div v-if="activeTab == 'coa'">
          <p class="text-xs">Kode akun harus sama persis dengan COA di Accurate supaya jurnal bisa diimpor.</p>
          <div class="row mb-3">
            <div class="col-md-3"><input type="text" class="form-control form-control-sm" placeholder="Kode Akun" v-model="account.code"></div>
            <div class="col-md-4"><input type="text" class="form-control form-control-sm" placeholder="Nama Akun" v-model="account.name"></div>
            <div class="col-md-2">
              <select class="form-select form-select-sm" v-model="account.type">
                <option v-for="(t, i) in setting.accountTypes" :key="'t'+i" :value="t">{{ t }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <argon-button variant="gradient" color="success" size="sm" @click="saveAccount()">{{ account.id ? 'Update' : '+ Tambah Akun' }}</argon-button>
              <a href="javascript:void(0)" class="text-xs ms-2" v-if="account.id" @click="resetAccount()">batal</a>
            </div>
          </div>
          <table class="table table-sm align-items-center">
            <thead><tr><th class="text-xxs text-secondary">Kode</th><th class="text-xxs text-secondary">Nama</th><th class="text-xxs text-secondary">Tipe</th><th></th></tr></thead>
            <tbody>
              <tr v-for="(a, i) in setting.accounts" :key="'acc'+i">
                <td class="text-xs font-weight-bold">{{ a.code }}</td>
                <td class="text-xs">{{ a.name }}</td>
                <td class="text-xs">{{ a.type }}</td>
                <td class="text-xs">
                  <i class="fas fa-edit" style="cursor: pointer; margin-right: 12px;" title="Ubah akun" @click="account = Object.assign({}, a)"></i>
                  <i class="fa fa-trash" style="cursor: pointer;" title="Hapus akun" @click="deleteAccount(a)"></i>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- PAJAK -->
        <div v-if="activeTab == 'tax'">
          <div class="row mb-4">
            <div class="col-md-3">
              <label class="form-control-label">Tarif PPN default (%)</label>
              <input type="number" step="0.01" min="0" class="form-control form-control-sm" v-model="setting.ppnRate">
            </div>
            <div class="col-md-3"><argon-button style="margin-top: 30px;" variant="gradient" color="success" size="sm" @click="saveTax()">Simpan</argon-button></div>
          </div>

          <h6 class="text-sm">Objek PPh</h6>
          <p class="text-xs">Tarif PPh 23 otomatis 2x untuk vendor tanpa NPWP.</p>
          <div class="row mb-3">
            <div class="col-md-2"><input type="text" class="form-control form-control-sm" placeholder="Kode" v-model="pph.code"></div>
            <div class="col-md-4"><input type="text" class="form-control form-control-sm" placeholder="Nama objek PPh" v-model="pph.name"></div>
            <div class="col-md-2">
              <select class="form-select form-select-sm" v-model="pph.pph_type"><option value="23">PPh 23</option><option value="4(2)">PPh 4(2)</option></select>
            </div>
            <div class="col-md-1"><input type="number" step="0.001" min="0" class="form-control form-control-sm" placeholder="%" v-model="pph.rate"></div>
            <div class="col-md-1 pt-1"><input type="checkbox" class="form-check-input" v-model="pph.active" title="Aktif"> <span class="text-xs">Aktif</span></div>
            <div class="col-md-2">
              <argon-button variant="gradient" color="success" size="sm" @click="savePph()">{{ pph.id ? 'Update' : '+ Tambah' }}</argon-button>
              <a href="javascript:void(0)" class="text-xs ms-2" v-if="pph.id" @click="resetPph()">batal</a>
            </div>
          </div>
          <table class="table table-sm align-items-center">
            <thead><tr><th class="text-xxs text-secondary">Kode</th><th class="text-xxs text-secondary">Objek</th><th class="text-xxs text-secondary">Jenis</th><th class="text-xxs text-secondary text-center">Tarif</th><th class="text-xxs text-secondary text-center">Status</th><th></th></tr></thead>
            <tbody>
              <tr v-for="(p, i) in setting.pphObjects" :key="'p'+i">
                <td class="text-xs font-weight-bold">{{ p.code }}</td>
                <td class="text-xs">{{ p.name }}</td>
                <td class="text-xs">PPh {{ p.pph_type }}</td>
                <td class="text-xs text-center">{{ Number(p.rate) }}%</td>
                <td class="text-xs text-center">{{ p.active ? 'Aktif' : 'Nonaktif' }}</td>
                <td class="text-xs"><i class="fas fa-edit" style="cursor: pointer;" title="Ubah objek PPh" @click="pph = Object.assign({}, p, { active: !!p.active })"></i></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonButton from "@/components/ArgonButton.vue";
import Api from '@/helpers/api';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import accounting from '@/services/accounting/accounting.service';

export default {
  name: "AccSetting",
  components: { ArgonButton },
  data() {
    return {
      activeTab: 'mapping',
      tabs: [
        { key: 'mapping', label: 'Mapping Akun' },
        { key: 'coa', label: 'Daftar Akun (COA)' },
        { key: 'tax', label: 'Pajak (PPN & PPh)' },
      ],
      requiredKeys: ['grni', 'ap', 'ppn_in', 'pph23_payable', 'pph42_payable', 'bank_default', 'gr_debit_default'],
      setting: { accounts: [], mappings: [], pphObjects: [], ppnRate: 11, accountTypes: [] },
      account: {},
      pph: {},
    };
  },
  mounted() {
    this.resetAccount();
    this.resetPph();
    this.get();
  },
  methods: {
    get() {
      let context = this;
      Api(context, accounting.accountingSetting()).onSuccess(function(response) {
          context.setting = response.data.data;
      }).onError(function() {
          context.notify('Data Retrieved Failed', 'error')
      })
      .call()
    },
    run(service, message) {
      let context = this;
      Api(context, service).onSuccess(function() {
          context.notify(message, 'success')
          context.get();
      }).onError(function(error) {
          context.notify((error.response && error.response.data.message) ? error.response.data.message : 'Gagal Disimpan', 'error')
      })
      .call();
    },
    saveMappings() {
      this.run(accounting.saveMappings({ mappings: this.setting.mappings.map(m => ({ map_key: m.map_key, account_code: m.account_code })) }), 'Mapping Disimpan');
    },
    resetAccount() {
      this.account = { id: null, code: '', name: '', type: 'Asset' };
    },
    saveAccount() {
      if (!this.account.code || !this.account.name) {
        return alert('Kode dan Nama Akun wajib diisi');
      }
      this.run(accounting.saveAccount(this.account), 'Akun Disimpan');
      this.resetAccount();
    },
    deleteAccount(a) {
      if (confirm('Hapus akun '+a.code+' - '+a.name+'?')) {
        this.run(accounting.deleteAccount(a.id), 'Akun Dihapus');
      }
    },
    saveTax() {
      this.run(accounting.saveTaxSetting({ ppn_rate: this.setting.ppnRate }), 'Tarif PPN Disimpan');
    },
    resetPph() {
      this.pph = { id: null, code: '', name: '', pph_type: '23', rate: '', active: true };
    },
    savePph() {
      if (!this.pph.code || !this.pph.name || this.pph.rate === '') {
        return alert('Kode, Nama, dan Tarif wajib diisi');
      }
      this.run(accounting.savePphObject(Object.assign({}, this.pph, { active: this.pph.active ? 1 : 0 })), 'Objek PPh Disimpan');
      this.resetPph();
    },
    notify(message, type) {
      if (type == 'success') {
        toast.success(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 2000 });
      } else {
        toast.error(message, { position: toast.POSITION.BOTTOM_RIGHT, autoClose: 4000 });
      }
    },
  }
};
</script>
